import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import formatDate from '../../../../components/common/formatDate';
import { TableCompHead } from '../../../../components/ui';
import CustomSelect from '../../../../components/common/SelectField';
import { MenuItem } from '@mui/material';

interface IProps {
  moduleData: any;
  isView: boolean;
}
const THead = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <thead>
      <TableCompHead
        colSpan={12}
        rowSpan={3}
        labels={['Doc No', 'Rev No', 'Date']}
        values={['FM/QA/10', '-', '-']}
        heading="PDI REPORT"
      />
      <tr>
        <th colSpan={2} align="left">
          Part Name
        </th>
        <th colSpan={3} align="left">
          {moduleData.part_name
            ? moduleData.part_name
            : moduleData.part_id?.part_name}
        </th>
        <th colSpan={2}>
          SHIFT:
          {isView ? (
            moduleData.shift
          ) : (
            <CustomSelect
              name="shift"
              value={moduleData?.shift || ''}
              onChange={(e) => {
                moduleData.shift = e.target.value;
                setRender((prev) => !prev);
              }}
            >
              <MenuItem value="A">A</MenuItem>
              <MenuItem value="B">B</MenuItem>
            </CustomSelect>
          )}
        </th>
        <th colSpan={2} align="left">
          Date
        </th>
        <th colSpan={3} align="left">
          {isView ? (
            formatDate(moduleData.pdir_date)
          ) : (
            <DatePickerMui
              label="Final Inspection Date"
              value={moment(moduleData.pdir_date)}
              onChange={(date) => {
                moduleData.pdir_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          Part No.
        </th>
        <th colSpan={3} align="left">
          {moduleData.part_number
            ? moduleData.part_number
            : moduleData.part_id?.part_number}
        </th>
        <th colSpan={2}></th>
        <th colSpan={2} align="left">
          Lot Qty.:
        </th>
        <th colSpan={3} align="left">
          <TableInput
            name="qty"
            type="text"
            value={moduleData.qty}
            onChange={(e) => {
              moduleData.qty = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          Model
        </th>
        <th colSpan={3} align="left">
          <TableInput
            name="model"
            type="text"
            value={moduleData.model}
            onChange={(e) => {
              moduleData.model = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={2}></th>
        <th colSpan={2} align="left">
          Invoice No.
        </th>
        <th colSpan={3} align="left">
          <TableInput
            name="invoice_no"
            type="text"
            value={moduleData.invoice_no}
            onChange={(e) => {
              moduleData.invoice_no = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          Customer
        </th>
        <th colSpan={3} align="left">
          {moduleData.customer_name
            ? moduleData.customer_name
            : moduleData.customer_id?.customer_name}
        </th>
        <th colSpan={2}></th>
        <th colSpan={2} align="left">
          Page No.
        </th>
        <th colSpan={3} align="left">
          01 OF 01
        </th>
      </tr>
      <tr>
        <th colSpan={12}>Part Sketch</th>
      </tr>
      {moduleData.image && (
        <tr style={{ height: '400px' }}>
          <th colSpan={12}>
            <img
              src={moduleData.image}
              alt="sketch"
              height="100%"
              width="auto"
            />
          </th>
        </tr>
      )}

      <tr>
        {[
          'S.No.',
          'Item Discription',
          'Specification',
          'Inspection Method',
        ].map((head) => (
          <th rowSpan={2} style={{ textTransform: 'uppercase' }}>
            {head}
          </th>
        ))}
        <th colSpan={6} style={{ textTransform: 'uppercase' }}>
          Observations
        </th>
        <th style={{ textTransform: 'uppercase' }} rowSpan={2} colSpan={2}>
          Remarks
        </th>
      </tr>
      <tr>
        {Array.from({ length: 5 }, (_, index) => (
          <th style={{ width: '100px' }} key={index + 'Heading'}>
            {index + 1}
          </th>
        ))}
        <th style={{ textTransform: 'uppercase' }}>Status</th>
      </tr>
    </thead>
  );
};

export default THead;
